import { z } from "zod";

export const FOOD_CATEGORIES = [
  "unconfirmed",
  "vegetarian",
  "non_vegetarian",
  "vegan",
  "contains_egg",
] as const;
export const FOOD_CATEGORY_LABELS: Record<
  (typeof FOOD_CATEGORIES)[number],
  string
> = {
  unconfirmed: "Dietary info unconfirmed",
  vegetarian: "Vegetarian",
  non_vegetarian: "Non-vegetarian",
  vegan: "Vegan",
  contains_egg: "Contains egg",
};
export const foodDietarySchema = z
  .object({
    category: z.enum(FOOD_CATEGORIES),
    glutenFree: z.boolean().default(false),
  })
  .strict();
export type FoodDietary = z.infer<typeof foodDietarySchema>;
